import ThrowsValidationError from 'common/http/throwsValidationError';
import UserPreference from './userPreference';
import HttpService from 'common/http/httpService';


class UserPreferenceService extends HttpService {

    async listAllPreferences() {
        const response = await this.getClient().get<UserPreference[]>('/settings/v1/user-preferences');
        return response.data;
    }

    async getUserPreferences(keys: string[]): Promise<UserPreference[]> {
        const response = await this.getClient().get<UserPreference[]>('/settings/v1/user-preferences', {
            params: { keys: keys?.join(',')}
        });
        return response.data;
    }

    @ThrowsValidationError()
    async updateUserPreference(key: string, value: string): Promise<any> {
        await this.getClient().put(`/settings/v1/user-preferences/${key}`, { value: value });
    }
}

const userPreferenceService = new UserPreferenceService();
export default userPreferenceService;


